/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminBillingService {
    /**
     * Get billing statistics with tier breakdown
     * @returns any Billing statistics with Pro and Business counts
     * @throws ApiError
     */
    public static adminBillingControllerGetBillingStatsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/stats',
        });
    }
    /**
     * Get all paid user IDs for filtering
     * @returns any List of user IDs with active paid subscriptions
     * @throws ApiError
     */
    public static adminBillingControllerGetPaidUserIdsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/paid-user-ids',
        });
    }
    /**
     * Get all Pro user IDs for filtering (deprecated, use paid-user-ids)
     * @returns any List of user IDs with active Pro subscriptions
     * @throws ApiError
     */
    public static adminBillingControllerGetProUserIdsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/pro-user-ids',
        });
    }
    /**
     * Search users by name or email
     * @param q
     * @returns any Users found
     * @throws ApiError
     */
    public static adminBillingControllerSearchUsersV1(
        q: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/users/search',
            query: {
                'q': q,
            },
        });
    }
    /**
     * Get all users with pagination
     * @param page
     * @param limit
     * @returns any Paginated users list
     * @throws ApiError
     */
    public static adminBillingControllerGetAllUsersV1(
        page: number,
        limit: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/users',
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * Get detailed billing info for a user
     * @param userId
     * @returns any User billing information including credit balance
     * @throws ApiError
     */
    public static adminBillingControllerGetUserBillingInfoV1(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/users/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * Reset usage for a specific feature
     * @param userId
     * @param requestBody
     * @returns any Feature usage reset successfully
     * @throws ApiError
     */
    public static adminBillingControllerResetUserFeatureV1(
        userId: string,
        requestBody: {
            /**
             * The feature to reset usage for
             */
            feature: 'AgentMessageCount' | 'ImageGenerationCount' | 'CreditBalance';
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/users/{userId}/reset-feature',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change user plan/tier
     * @param userId
     * @param requestBody
     * @returns any Plan changed successfully
     * @throws ApiError
     */
    public static adminBillingControllerChangeUserPlanV1(
        userId: string,
        requestBody: {
            /**
             * The tier to change the user to
             */
            tier: 'Free' | 'Pro' | 'Business';
            /**
             * Duration: daily, weekly, monthly, yearly, or lifetime
             */
            duration?: 'daily' | 'three_day' | 'weekly' | 'two_week' | 'monthly' | 'two_month' | 'three_month' | 'six_month' | 'yearly' | 'lifetime';
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/users/{userId}/change-plan',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change the subscription plan for a business
     * @param businessId
     * @param requestBody
     * @returns any Business billing info after plan change
     * @throws ApiError
     */
    public static adminBillingControllerChangeBusinessPlanV1(
        businessId: string,
        requestBody: {
            /**
             * Target tier
             */
            tier: 'Free' | 'Pro' | 'Business';
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/business/{businessId}/change-plan',
            path: {
                'businessId': businessId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get per-user credit usage (transactions filtered by userId)
     * @param userId
     * @param limit
     * @param offset
     * @returns any User credit usage data
     * @throws ApiError
     */
    public static adminBillingControllerGetUserCreditUsageV1(
        userId: string,
        limit: number,
        offset: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/users/{userId}/credit-usage',
            path: {
                'userId': userId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get business billing info including credits and transactions
     * @param businessId
     * @param txLimit
     * @param txOffset
     * @returns any Business billing information
     * @throws ApiError
     */
    public static adminBillingControllerGetBusinessBillingInfoV1(
        businessId: string,
        txLimit: number,
        txOffset: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/billing/business/{businessId}',
            path: {
                'businessId': businessId,
            },
            query: {
                'txLimit': txLimit,
                'txOffset': txOffset,
            },
        });
    }
    /**
     * Grant credits to a business (admin)
     * @param businessId
     * @param requestBody
     * @returns any Credits granted successfully
     * @throws ApiError
     */
    public static adminBillingControllerGrantCreditsV1(
        businessId: string,
        requestBody: {
            /**
             * Number of credits to grant
             */
            amount: number;
            /**
             * Reason for granting credits
             */
            description?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/business/{businessId}/grant-credits',
            path: {
                'businessId': businessId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Refund credits to a business (admin)
     * @param businessId
     * @param requestBody
     * @returns any Credits refunded successfully
     * @throws ApiError
     */
    public static adminBillingControllerRefundCreditsV1(
        businessId: string,
        requestBody: {
            /**
             * Number of credits to refund
             */
            amount: number;
            /**
             * Reason for refund
             */
            description?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/business/{businessId}/refund-credits',
            path: {
                'businessId': businessId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Re-point a subscription to another business of the same user (admin repair)
     * Repairs the wrong-business purchase class (RC webhook attaches purchases to the user's oldest business): moves the subscription row to the target business, marks it setup-complete, and optionally moves the initial credit grant (clamped to the source's available subscription credits).
     * @param subscriptionId
     * @param requestBody
     * @returns any Repair outcome (movedCredits is the actual amount)
     * @throws ApiError
     */
    public static adminBillingControllerRepairSubscriptionBusinessV1(
        subscriptionId: string,
        requestBody: {
            /**
             * Business the subscription should belong to (payer must be a member)
             */
            targetBusinessId: string;
            /**
             * Subscription credits to move from the old business to the target
             */
            moveCredits?: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/subscriptions/{subscriptionId}/repair-business',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Recreate a local subscription row from live RevenueCat state (admin repair)
     * Repairs the orphaned-billing class: RC bills a customer whose local subscription row was destroyed (business deleted mid-dunning, out-of-band deletion). Reads the customer's live RC subscriptions, picks the longest-running paid one, and recreates the local row on the given business with the initial credit grant. Never writes to RC.
     * @param userId
     * @param requestBody
     * @returns any Recreation outcome (product, endDate, credits)
     * @throws ApiError
     */
    public static adminBillingControllerRecreateSubscriptionFromRcV1(
        userId: string,
        requestBody: {
            /**
             * Business the recreated subscription should belong to (user must be a member)
             */
            businessId: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/billing/users/{userId}/recreate-subscription',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
